import { render, staticRenderFns } from "./InstanceFeedback.vue?vue&type=template&id=92d0f098&scoped=true&"
import script from "./InstanceFeedback.vue?vue&type=script&lang=js&"
export * from "./InstanceFeedback.vue?vue&type=script&lang=js&"
import style0 from "./InstanceFeedback.vue?vue&type=style&index=0&id=92d0f098&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92d0f098",
  null
  
)

export default component.exports